<template>
  <transition name="fade">
    <div v-if="showToast" class="toast">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastMessage",
  data() {
    return {
      showToast: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showToast = false;
    }, 5000);
  },
};
</script>

<style lang="scss" scoped>
.toast {
  padding: 6px 10px;
  background: rgba($color-grey-dark, 0.7);
  @include t__utility-label-20;
  color: $color-white;
  display: inline-block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
